import React, { useState } from 'react';
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TablePagination, TextField, Stack, IconButton, Tooltip } from '@mui/material';
import { AddCircle, Search } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

function GeneralTable({ columns, data }) {
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [search, setSearch] = useState("");
    const navigate = useNavigate();

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleSearchChange = (event) => {
        setSearch(event.target.value.toLowerCase());
        setPage(0);
    };

    const filteredData = data.filter((row, index) =>
        columns.some((col) => {
            let value;

            if (col.format) {
                value = col.format(row);
            } else {
                value = col.key.includes('.')
                    ? col.key.split('.').reduce((obj, key) => obj?.[key], row)
                    : row[col.key];
            }

            return String(value ?? "").toLowerCase().includes(search);
        })
    );


    return (
        <Paper sx={{ padding: 2, width: "95%" }}>

            <Stack direction={'row'} spacing={2} sx={{ marginBottom: 2 }}>
                <TextField
                    label="Buscar ejecutivo"
                    variant="standard"
                    onChange={handleSearchChange}
                    fullWidth
                    sx={{ textAlign: 'left' }}
                    InputProps={{
                        startAdornment: <Search sx={{ marginRight: 1, color: 'gray' }} />,
                    }}
                />
                <Tooltip title='Agregar nuevo' placement='top'>
                    <IconButton
                        color="primary"
                        aria-label="add to shopping cart"
                        sx={{ marginTop: '5px' }}
                        onClick={() => navigate('/suppliers/executive/create-new')}
                    >
                        <AddCircle />
                    </IconButton>
                </Tooltip>
            </Stack>
            <TableContainer>
                <Table sx={{ minWidth: 650 }} size="medium" aria-label="custom table">
                    <TableHead sx={{ backgroundColor: "#10173c" }}>
                        <TableRow>
                            {columns.map((col) => (
                                <TableCell key={col.key} align={col.align} sx={{ color: "white" }}>
                                    {col.label}
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => {
                            const rowIndex = page * rowsPerPage + index;
                            return (
                                <TableRow key={rowIndex}>
                                    {columns.map((col) => (
                                        <TableCell
                                            key={col.key}
                                            align={col.align}
                                            sx={col.style}
                                        >
                                            {col.customRender
                                                ? col.customRender(row, rowIndex)
                                                : col.format
                                                    ? col.format(row)
                                                    : col.key.includes('.')
                                                        ? col.key.split('.').reduce((obj, key) => obj?.[key], row) ?? "—"
                                                        : row[col.key] ?? "—"}
                                        </TableCell>
                                    ))}
                                </TableRow>
                            );
                        })}

                    </TableBody>
                </Table>
            </TableContainer>
            <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                count={filteredData.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
            />
        </Paper>
    );
}

export default GeneralTable;
